<template>
  <div id="dashboard-analytics">
    <vx-card class="vx-col w-full mb-base mr-5" style="overflow-x: auto">
      <div class="w-full flex justify-left items-center ">
        <div class="mr-1">
          <b class="w-full">Filtrar dados por periodo</b>
          <div class="w-full mt-4 items-center">
            <span class="text-sm">Atualização Automática</span>
            <vs-select v-model="autoSync" icon="schedule" width="150px" size="small">
              <vs-select-item :key="1" :value="false" text="Desligado"/>
              <vs-select-item :key="2" :value="1" text="1 Min"/>
              <vs-select-item :key="5" :value="5" text="5 Min"/>
              <vs-select-item :key="10" :value="10" text="10 Min"/>
            </vs-select>
          </div>
        </div>
        <flat-pickr
          class="ml-8"
          :config="initialConfigdateTimePicker"
          v-model="initial_date"
          ref="initial"
          placeholder="Intervalo inicial"
        />
        <flat-pickr
          class="ml-8"
          :config="finalConfigdateTimePicker"
          v-model="finish_date"
          ref="final"
          placeholder="Intervalo final"
        />
        <div class="ml-8">
          <div class="w-64 w-12/12">
            <vs-radio class="mr-2" v-model="reportDepartment" vs-name="reportDepartment" vs-value="all">
              Sem filtro
            </vs-radio>
            <vs-radio v-model="reportDepartment" vs-name="reportDepartment" vs-value="specific">
              Departamento Específico
            </vs-radio>
            <vs-radio v-if="isControlPanel" v-model="reportDepartment" vs-name="reportDepartment" vs-value="category">
              Categoria Específica
            </vs-radio>
            <vs-radio v-if="isControlPanel" v-model="reportDepartment" vs-name="reportDepartment" vs-value="instance">
              Conexão Específica
            </vs-radio>
          </div>
        </div>
        <div class="ml-8 w-full inline-flex">
          <vs-button  @click="filterDateAnalytics()" :disabled="buttonDisabled">
            Filtrar
          </vs-button>
          <vx-tooltip class="ml-8 mr-5" text="Essa função está em testes, pode ocorrer de não carregar todos os dados quando for um intervalo de tempo maior.">
            <feather-icon icon="HelpCircleIcon"></feather-icon>
          </vx-tooltip>
        </div>
      </div>
    </vx-card>

    <div v-if="reportDepartment === 'specific'">
      <vx-card class="vx-col w-full mb-base">
        <div>
          <user-departments-slim-list checkbox search :selecteds="selectedDepartment" @selectedDepartment="selectDepartment" />
        </div>
      </vx-card>
    </div>

    <div v-if="isControlPanel && reportDepartment === 'category'">
      <vx-card class="vx-col w-full mb-base">
        <div>
          <customer-category-slim-list checkbox search :selecteds="selectedCategory" @selectedGroup="selectCategory" />
        </div>
      </vx-card>
    </div>

    <div v-if="isControlPanel && reportDepartment === 'instance'">
      <vx-card class="vx-col w-full mb-base">
        <div>
          <instances-slim-list checkbox search :selecteds="selectedInstance" @selectedInstances="selectInstance"/>
        </div>
      </vx-card>
    </div>

    <div v-for="(value, index) in dashFilter" :key="index">
      <iframe
        ref="iframe"
        scrolling="no"
        allowtransparency
        :src="value[1]['url']"
        class="iframe mb-5"
        :class="'iframe-'+value[0]"
      ></iframe>
    </div>
  </div>
</template>
<script>

import jwt from 'jsonwebtoken';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import VxTimeline from "@/components/timeline/VxTimeline.vue"
import { delay, getCurrentTenant } from "@/utils";
import UsersTable from "@/views/report/UsersTable.vue";
import UserDepartmentsSlimList from "@/views/user-departments/UserDepartmentsSlimList.vue";
import CustomerCategorySlimList from "@/views/customer-groups/CustomerCategorySlimList.vue";
import InstancesSlimList from "@/views/instances/InstancesSlimList.vue";

export default {
  components: {InstancesSlimList, CustomerCategorySlimList, UserDepartmentsSlimList, UsersTable, VxTimeline, flatPickr},
  data() {
    return {
      selectedCategory: [0],
      selectedInstance: [0],
      selectedDepartment: [0],
      reportDepartment: 'all',
      initial_date: null,
      finish_date: null,
      autoSync: false,
      autoSyncData: null,
      buttonDisabled: false,
      initialConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        dateFormat: 'd/m/Y',
        maxDate: new Date(),
        onChange: this.calendarChange
      },
      finalConfigdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        minDate: null,
        maxDate: new Date(),
        dateFormat: 'd/m/Y',
      },
      typesOfDash: {
        'dafault'       : { dashboard: 8,  url: null },
        'cloud'         : { dashboard: 9,  url: null },
        'control-panel' : { dashboard: 16, url: null }
      },
      payload: {
        resource: {},
        params: {},
        exp: Math.round(Date.now() / 1000) + (99 * 1024)
      },
    }
  },
  computed: {
    initialDate(){
      return this.stringToDate(this.initial_date,"dd/MM/yyyy","/");
    },
    isControlPanel(){
      return this.$route.name && this.$route.name.includes('control-panel')
    },
    finishDate(){
      let finishedDate = this.stringToDate(this.finish_date,"dd/MM/yyyy","/")
      finishedDate.setHours(23,59,59, 9998)
      return finishedDate;
    },
    hasOfficial(){
      return this.$store.state.instance.existsCloudConnection
    },
    dashFilter(){
      return Object.entries(this.typesOfDash).filter(([key]) => {
        return ( this.isControlPanel && key === 'control-panel') || (
          !this.isControlPanel && (key === 'dafault' || (key === 'cloud' && this.hasOfficial))
        )
      });
    }
  },
  watch:{
    autoSync(minutes){
      if (minutes){
        clearInterval(this.autoSyncData);
        this.autoSyncData = setInterval(() => {
          this.filterDateAnalytics();
        }, minutes * 60000)
      } else {
        clearInterval(this.autoSyncData);
        this.autoSyncData = null;
      }
    },
    '$route.name'(value){
      if (value){
        this.loadMetabase();
        this.clear();
      }
    },
    reportDepartment(){
      this.selectedDepartment = [0]
      this.selectedCategory = [0]
      this.selectedInstance = [0]
    }
  },
  methods: {
    delay,
    stringToDate(_date,_format,_delimiter){
      let formatLowerCase = _format.toLowerCase();
      let formatItems = formatLowerCase.split(_delimiter);
      let dateItems = _date.split(_delimiter);
      let dayIndex = formatItems.indexOf("dd");
      let monthIndex = formatItems.indexOf("mm");
      let yearIndex = formatItems.indexOf("yyyy");
      let month = parseInt(dateItems[monthIndex]);
      month-=1;

      return new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
    },
    selectDepartment(department){
      this.selectedDepartment = department
    },
    selectCategory(category){
      this.selectedCategory = category
    },
    selectInstance(instance){
      this.selectedInstance = instance
    },
    calendarChange(selectedDates) {
      this.finalConfigdateTimePicker.minDate = selectedDates[0]
    },
    filterDateAnalytics(){
      this.buttonDisabled = true
      this.timeout = setTimeout(() => { this.buttonDisabled = false }, 2000)
      this.loadMetabase()
    },
    loadMetabase(){
      this.dashFilter.map(([key, data]) => {

        this.payload.params = this.updateArgs();
        this.payload.resource = {dashboard: data['dashboard']}
        let token = jwt.sign(this.payload,  process.env.VUE_APP_METABASE_SECRET_KEY, '', '');

        this.typesOfDash[key]['url'] = process.env.VUE_APP_METABASE_SITE_URL + "/embed/dashboard/" + token + "#bordered=false&titled=false";
      })
    },
    updateArgs() {
      return  {
        'tenant': getCurrentTenant() + '.',
        'data_final': this.finishDate,
        'data_inicial': this.initialDate,
        'instance_ids': this.selectedInstance.toString(),
        'department_ids': this.selectedDepartment.toString(),
        'groups_of_customer_id': this.selectedCategory.toString(),
        'tenant_ids': '0'
      }
    },
    clear(){
      this.reportDepartment = 'all';
      this.selectedCategory = [0];
      this.selectedInstance = [0];
      this.selectedDepartment = [0];
    }
  },
  async beforeMount() {
    const today = new Date()
    const yyyy = today.getFullYear()
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const todayDay = String(today.getDate()).padStart(2, '0')

    this.initial_date = `${todayDay}/${mm}/${yyyy}`
    this.finish_date = `${todayDay}/${mm}/${yyyy}`

    this.$store.dispatch('setShowLoadingOverlay', true);

    if ( !this.hasOfficial ){
      await this.delay(3000);
    }

    this.$store.dispatch('setShowLoadingOverlay', false);

    this.clear();
    this.loadMetabase();
  },
  beforeDestroy() {
    this.clear();
    if (this.autoSyncData){
      clearInterval(this.autoSyncData);
      this.autoSyncData = null;
      this.autoSync = false;
    }
  }
}
</script>

<style lang="scss">

#dashboard-analytics {
  .loading-dashboard-graphs {
    height: 11rem;
    width: 100%;
  }

  .iframe{
    width: 100%;
    border: none;
    display: block;
    overflow-y: auto;
    border-radius: 20px;
    overflow-x: hidden;
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  }

  .iframe-dafault{
    height: 195vw;
  }

  .iframe-cloud{
    height: 50vw;
  }

  .iframe-control-panel{
    height: 70vw;
  }

  @media(max-width: 1230px) {
    .iframe-dafault{
      height: 310vw !important;
    }

    .iframe-cloud{
      height: 150vw !important;
    }

    .iframe-control-panel{
      height: 170vw  !important;
    }
  }

  @media(max-width: 920px) {
    .iframe-dafault{
      height: 340vw !important;
    }

    .iframe-cloud{
      height: 200vw !important;
    }

    .iframe-control-panel{
      height: 220vw  !important;
    }
  }

  @media(max-width: 750px) {
    .iframe-dafault{
      height: 1100vw !important;
    }

    .iframe-control-panel{
      height: 350vw  !important;
    }
  }
  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
    .iframe-dafault{
      height: 1650vw !important;
    }
  }
}

</style>
